module.exports = __webpack_public_path__ + "static/media/Differential Housing.ea6c782f.webp";